import PageRoutes from './pages/routes.tsx';
import './styles/main.css';

function App() {
  return (
    <>
      <PageRoutes />
    </>
  );
}

export default App;
